export default __webpack_public_path__ + "static/media/standsExpo_viakon.a89014eb.jpg";